export default {"src":"/_next/static/media/sortIcon.5ba334b1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};